<div class="logs-page-container">
    <div class="search-bar">
        <mat-form-field appearance="outline" class="full-width">
            <mat-icon matPrefix>search</mat-icon>
            <input
                matInput
                placeholder="Buscar controles"
                #searchInput
                (keyup)="onSearchChange(searchInput.value)"
            />
        </mat-form-field>
    </div>

    <div class="logs-container">
        @if (groupedLogs.length > 0) {
        <mat-accordion multi>
            @for (group of groupedLogs; track group) {
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title">
                        Controle de Leite
                        <span class="panel-subtitle">{{
                            group.milkControl.startedAt | date: 'dd/MM/yyyy'
                        }}</span>
                    </mat-panel-title>
                    <mat-panel-description class="panel-producer-code">
                        Produtor: {{ group.milkControl.producer?.code }}
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="milk-control-details">
                    <div class="detail-grid">
                        <div class="detail-item">
                            <span>Status</span>
                            <strong>{{
                                group.milkControl.status === 'OPEN' ? 'Aberto' : 'Fechado'
                            }}</strong>
                        </div>
                        <div class="detail-item">
                            <span>Iniciado em</span>
                            <strong>{{
                                group.milkControl.startedAt | date: 'dd/MM/yyyy HH:mm'
                            }}</strong>
                        </div>
                        @if (group.milkControl.finishedAt) {
                        <div class="detail-item">
                            <span>Finalizado em</span>
                            <strong>{{
                                group.milkControl.finishedAt | date: 'dd/MM/yyyy HH:mm'
                            }}</strong>
                        </div>
                        }
                    </div>
                    <div class="milkings-list">
                        @for (milking of group.milkControl.milkings; track milking; let i = $index)
                        {
                        <div class="milking-item">
                            <span>Ordenha {{ i + 1 }}</span>
                            <strong class="milking-count"
                                >{{ milking.milkedAnimals.length }} animais</strong
                            >
                        </div>
                        }
                    </div>
                </div>
            </mat-expansion-panel>
            }
        </mat-accordion>
        } @if (isLoading) {
        <div class="loading-indicator">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
        } @if (!isLoading && hasMoreLogs && groupedLogs.length > 0) {
        <div class="load-more-container">
            <button mat-stroked-button color="primary" (click)="loadMore()">Carregar Mais</button>
        </div>
        } @if (!hasMoreLogs && !isLoading && groupedLogs.length > 0 && currentPage > 0) {
        <div class="empty-state">Fim dos resultados</div>
        } @if (!isLoading && groupedLogs.length === 0) {
        <div class="empty-state">Nenhum log encontrado</div>
        }
    </div>
</div>
